export enum ELocalstorageKeys {
  TABLE_GAMES_COLUMN_VISIBILITY = 'tableGamesColumnVisibility',
  TABLE_GAMES_COLUMN_FILTERS = 'tableGamesColumnFilters',
  TABLE_PLAYERS_COLUMN_VISIBILITY = 'tablePlayersColumnVisibility',
  TABLE_PLAYERS_COLUMN_FILTERS = 'tablePlayersColumnFilters',
}
